import SEO from "@/components/common/SEO";
import PageHeader from "@/components/shared/PageHeader";
import { company } from "@/data/site";

const content = {
  privacy: {
    title: "Privacy Policy",
    overline: "Legal",
    sections: [
      { h: "Overview", p: `${company.name} respects your privacy. This policy explains what information we collect, how we use it, and the choices you have.` },
      { h: "Information we collect", p: "We collect information you provide directly — such as your name, email, phone and message when you contact us or subscribe to our newsletter. We also collect basic analytics data to improve our website." },
      { h: "How we use information", p: "We use your information to respond to enquiries, deliver our services, send requested communications and improve our offerings. We never sell your personal data." },
      { h: "Data security", p: "We apply industry-standard technical and organizational measures to protect your data, including encryption in transit and strict access controls." },
      { h: "Your rights", p: "You may request access to, correction of, or deletion of your personal data at any time by contacting us at " + company.email + "." },
      { h: "Cookies", p: "We use cookies to improve your experience and understand site usage. You can control cookies through your browser settings." },
    ],
  },
  terms: {
    title: "Terms of Service",
    overline: "Legal",
    sections: [
      { h: "Acceptance of terms", p: `By accessing or using the ${company.name} website, you agree to be bound by these terms of service.` },
      { h: "Use of the site", p: "You agree to use this site lawfully and not to misuse, disrupt or attempt unauthorized access to our systems or content." },
      { h: "Intellectual property", p: "All content, branding and materials on this site are the property of " + company.name + " unless otherwise stated, and may not be reproduced without permission." },
      { h: "Engagements", p: "Any services provided are governed by a separate signed agreement. These website terms do not constitute a contract for services." },
      { h: "Limitation of liability", p: "The site is provided 'as is'. To the fullest extent permitted by law, we are not liable for any indirect or consequential damages arising from its use." },
      { h: "Contact", p: "Questions about these terms can be directed to " + company.email + "." },
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const c = content[kind];
  return (
    <>
      <SEO title={c.title} description={`${c.title} for ${company.name}.`} path={`/${kind}`} />
      <PageHeader overline={c.overline} title={c.title} subtitle={`Last updated ${new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}.`} />
      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-3xl space-y-10 px-5 sm:px-8">
          {c.sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-display text-2xl font-medium tracking-tight">{s.h}</h2>
              <p className="mt-3 text-muted-foreground leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
